class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* Outfit: sugerencia en el carrito de un cinturon que haga juego (color y material) con el calzado elegido. */
(function () {
  if (window.__outfitBelt) return;
  window.__outfitBelt = true;
  var HANDLE = 'cinturon-outfit-para-caballero';
  var SKIP = ['cinturon-outfit-para-caballero', 'pantalon-en-dril-licrado'];
  var belt = null;
  var beltPromise = null;
  var timer = null;

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function loadBelt() {
    if (!beltPromise) {
      beltPromise = fetch('/products/' + HANDLE + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { belt = p; return p; })
        .catch(function () { return null; });
    }
    return beltPromise;
  }

  /* Color y material del calzado -> variante del cinturon (negro-gamuza, miel-brillante, cafe-gamuza, blanco-charol...). */
  function keyFor(item) {
    if (SKIP.indexOf(item.handle) > -1) return null;
    var colorTxt = '';
    (item.options_with_values || []).forEach(function (o) {
      if (norm(o.name) === 'color') colorTxt = norm(o.value);
    });
    if (!colorTxt) colorTxt = norm(String(item.variant_title || '').split('/')[0]);
    var all = norm(item.product_title) + ' ' + colorTxt;
    var mat = all.indexOf('gamuza') > -1 ? 'gamuza' : all.indexOf('charol') > -1 ? 'charol' : 'brillante';
    if (/blanco/.test(colorTxt)) return 'blanco-charol';
    if (/miel|conac/.test(colorTxt)) return mat === 'gamuza' ? 'miel-gamuza' : 'miel-brillante';
    if (/negro/.test(colorTxt)) return mat === 'gamuza' ? 'negro-gamuza' : mat === 'charol' ? 'negro-charol' : 'negro-brillante';
    if (/cafe|marron/.test(colorTxt)) return mat === 'gamuza' ? 'cafe-gamuza' : 'cafe-brillante';
    return null;
  }

  function money(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CO');
  }

  function imgUrl(src) {
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function render() {
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    var footer = document.querySelector('#CartDrawer .drawer__footer');
    if (!inner || !footer) return;
    Promise.all([fetch('/cart.js').then(function (r) { return r.json(); }), loadBelt()]).then(function (res) {
      var cart = res[0];
      var b = res[1];
      var old = document.getElementById('outfit-belt');
      if (!b || !cart || !cart.items || !cart.items.length) { if (old) old.remove(); return; }
      var inCart = {};
      cart.items.forEach(function (it) { if (it.handle === HANDLE) inCart[norm(it.variant_title)] = true; });
      var keys = [];
      cart.items.forEach(function (it) {
        var k = keyFor(it);
        if (k && !inCart[k] && keys.indexOf(k) < 0) keys.push(k);
      });
      keys = keys.slice(0, 2);
      var sig = keys.join('|') + '#' + cart.item_count;
      if (old && old.getAttribute('data-sig') === sig && old.parentNode === footer.parentNode) return;
      if (old) old.remove();
      var vars = keys.map(function (k) {
        return b.variants.filter(function (v) { return norm(v.title) === k && v.available; })[0];
      }).filter(Boolean);
      if (!vars.length) return;
      var box = document.createElement('div');
      box.id = 'outfit-belt';
      box.setAttribute('data-sig', sig);
      var html = '<style>#outfit-belt{margin:0 0 1rem;padding:1rem 1.5rem;border-top:1px solid rgba(0,0,0,.12)}#outfit-belt .ob-t{font-size:1.4rem;font-weight:700;margin:0 0 .8rem}#outfit-belt .ob-r{display:flex;align-items:center;gap:1rem;margin:0 0 .6rem}#outfit-belt img{width:56px;height:56px;object-fit:cover;border-radius:6px;background:#f3f3f3}#outfit-belt .ob-n{flex:1;font-size:1.3rem;line-height:1.3}#outfit-belt .ob-n b{display:block;text-transform:capitalize}#outfit-belt button{background:#66280a;color:#fff;border:0;border-radius:6px;padding:.8rem 1.2rem;font-size:1.3rem;font-weight:600;cursor:pointer}#outfit-belt button[disabled]{opacity:.6}</style><p class="ob-t">Hace juego con tu pedido</p>';
      vars.forEach(function (v) {
        var src = (v.featured_image && v.featured_image.src) || (b.featured_image || '');
        html += '<div class="ob-r">' + (src ? '<img src="' + imgUrl(src) + '" alt="" loading="lazy">' : '') + '<div class="ob-n"><b>Cinturón ' + v.title.replace(/-/g, ' ') + '</b>' + money(v.price) + '</div><button type="button" data-outfit-belt="' + v.id + '">Agregar</button></div>';
      });
      box.innerHTML = html;
      footer.parentNode.insertBefore(box, footer);
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(render, 250);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-outfit-belt]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = 'Agregando…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-outfit-belt')), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var drawer = document.querySelector('cart-drawer');
        if (data && data.sections && drawer && drawer.renderContents) {
          drawer.renderContents({ id: data.items && data.items[0] && data.items[0].id, sections: data.sections });
        } else {
          window.location.reload();
        }
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Agregar'; });
  });

  function start() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.closest && t.closest('#outfit-belt')) continue;
        schedule();
        return;
      }
    }).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
